import React from 'react'
import styled from 'styled-components'

const Marker = styled.div`
  display: flex;
  position: relative;
  align-items: center;

  & > * {
    flex: none;
  }
`

const Dot = styled.div`
  opacity: ${({ dim }) => (dim ? 0.6 : 0.9)};
  filter: blur(${({ dim }) => (dim ? 6 : 0)}px);
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size}px;
  background: ${({ theme, branch, colorize }) =>
    colorize ? theme.colors.branch[branch] : theme.colors.greys.mediumDark};
`

export default ({
  branch,
  size = 10,
  colorize = true,
  dim = false,
  onMarkerClick = x => x,
}) => {
  return (
    <Marker onClick={onMarkerClick}>
      <Dot branch={branch} size={size} colorize={colorize} dim={dim} />
    </Marker>
  )
}
